module.exports = __webpack_public_path__ + "static/media/crown-b.2eb79dd7.svg";